import { colors2, globalLightboxStyle } from "oolib";
import styled, { css } from "styled-components";
import { Z_INDEX } from "../../styled";
import { globalInputElemFocused_v2, globalInputElemHover_v2 } from "oolib/dist/v2/themes/globalStyles";

export const StyledReportsHeaderContainer = styled.div`
  padding: 0.6rem 1.4rem;
  border-bottom: 1px solid ${colors2.grey10};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledReportsHeaderTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: 1 1 auto;
  min-width: 0;
`;

// Scopes the title's hover tint to the title itself, so hovering elsewhere on
// the header bar doesn't trigger it.
export const StyledEditableTitleHover = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  ${({ readOnly }) => !readOnly && css`
    &:hover {
      #reportsHeaderTitle {
        background-color: ${colors2.grey10};
      }
    }
  `}
`;

export const StyledReportsHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  /* keep the actions intact and let the breadcrumb truncate instead */
  flex-shrink: 0;
`;

export const StyledReportsHeaderButtons = styled.div`
  display: flex;
  gap: 0.8rem;
`;

export const StyledReportsHeaderMenuWrapper = styled.div`
  position: relative;
  z-index: ${Z_INDEX.REPORTS_HEADER}; /* High value to stay above action menus on widgets */
`;

export const StyledOptionsDropdownWrapper = styled.div`
  position: relative;
`;

export const StyledOptionsDropdown = styled.div`
  position: absolute;
  top: calc(100% + 0.8rem);
  right: 0;
  min-width: 300px;
  background-color: ${colors2.white};
  z-index: ${Z_INDEX.REPORTS_HEADER + 1};
  ${globalLightboxStyle}
`;

